import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWand20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconWand20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m15.273 2.981-2.08 2.081 1.745 1.746 2.08-2.081zm-12.26 12.26 9.119-9.118 1.745 1.746-9.119 9.118zm-1.06-1.06a1.5 1.5 0 0 0 0 2.121l1.745 1.746a1.5 1.5 0 0 0 2.121 0l12.26-12.26a1.5 1.5 0 0 0 0-2.122l-1.745-1.745a1.5 1.5 0 0 0-2.122 0zm2.55-11.725a.75.75 0 0 1 .75.75v1.5H6.75a.75.75 0 1 1 0 1.5H5.253v1.497a.75.75 0 0 1-1.5 0V6.206H2.254a.75.75 0 1 1 0-1.5h1.499v-1.5a.75.75 0 0 1 .75-.75m7.995 11.26a.75.75 0 0 1 .75.75v.254h.25a.75.75 0 1 1 0 1.5h-.25v.244a.75.75 0 0 1-1.5 0v-.244h-.25a.75.75 0 0 1 0-1.5h.25v-.254a.75.75 0 0 1 .75-.75m4.767-3.638a.75.75 0 0 0-1.5 0v.752h-.749a.75.75 0 0 0 0 1.5h.75v.745a.75.75 0 0 0 1.5 0v-.745h.748a.75.75 0 0 0 0-1.5h-.749z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWand20);
